import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Homepage from './index.jsx'
import Services from './pages/services.jsx'
import ContactPage from './pages/contact.jsx'
import NotFoundPage from './pages/404.jsx'
import PalletsPage from './pages/pallets.jsx'
import About from './pages/about.jsx'

export default () => (
  <Routes>
    <Route path="/" element={<Homepage />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/services" element={<Services />} />
    <Route path="/pallets" element={<PalletsPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
)